import { Router } from '@angular/router';
import { WalletService } from './../../services/wallet.service';
import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { SendMessageComponent } from '../send-message/send-message.component';
import { NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { MessagingService } from '../../services/messaging.service';
import { JobOffersService } from '../../services/job-offers.service';
import { MessageBoxDialog } from '../message-box/message-box.component';
import {Pagination} from '../../models/message';
import { ApplyStatusService } from '../../services/apply-status.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-blockchain',
  templateUrl: './blockchain.component.html',
  styleUrls: ['./blockchain.component.css']
})
export class BlockchainComponent implements OnInit {
  selectedOption: string;
  loading: boolean;
  messagesDirect: any;
  messagesMassive: any;
  errorMessage: string;
  req: number;

  optionsModel: number[];
  myOptions: IMultiSelectOption[];

  jobId: string;
  jobs: Observable<any[]>;
  query: string;
  favorite: string;
  read: boolean;
  unread: boolean;
  rejected: boolean;
  selected: boolean;
  hired: boolean;
  offer_id: string;
  custom: any;

  paginationDirect: Pagination = {total: 0, pages: 0, pageCount: 0};
  maxMessagesDirect = 10;
  currentPageDirect = 1;

  paginationMassive: Pagination = {total: 0, pages: 0, pageCount: 0};
  maxMessagesMassive = 10;
  currentPageMassive = 1;

  mySettings: IMultiSelectSettings = {
      enableSearch: false,
      checkedStyle: 'glyphicon',
      buttonClasses: 'btn btn-default btn-block',
      dynamicTitleMaxItems: 10,
      displayAllSelectedText: true
  };

myTexts: IMultiSelectTexts = {
      checkAll: 'Seleccionar Todos',
      uncheckAll: 'Remover Todos',
      checked: 'Estado Seleccionado',
      checkedPlural: 'Estados Seleccionados',
      searchPlaceholder: 'Buscar',
      defaultTitle: 'Seleccionar Estado',
      allSelected: 'Seleccionar Todos',
  };

  constructor(public dialog: MdDialog,
    public walletService: WalletService,
    private jobService: JobOffersService,
    private router: Router,
    private applyStatusService: ApplyStatusService,

  ) { }

  ngOnInit() {
    this.searchWallets(1);
  }

  onChange($event) {
  }



  showDetailsMessage(title, content) {
      this.dialog.open(MessageBoxDialog, {data: {title: title, message: content, alert:true, showIcon:false}});
  }

  searchWallets(page) {

    this.loading = true;

    let wallets;

      wallets = this.walletService.getWallets(page);

    wallets.subscribe(
      data => {
          this.messagesDirect = data.wallets;
          this.paginationDirect = data.pagination;
          this.currentPageDirect = page;

        this.loading = false;
      },
      error => {
          console.log(error);
          this.loading = false;
      }
    );
  }

  openDialog() {
      const dialogRef = this.dialog.open(SendMessageComponent, {data: {
        nameComponent: 'message', useFilter: true, jobs: this.jobs
      }});

      dialogRef.afterClosed().subscribe(result => {
        this.selectedOption = result;
      });
  }

  onPageChange(page) {
    this.searchWallets(page);
  }

  clickWallet(id) {
    this.router.navigate(['/pages/wallet/' + id]);
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data: {message: 'Podrás ver el estado de los mensajes enviados a los candidatos de forma individual o masiva, recuerda que este modulo solo te podrá informar si el candidato leyó o no el mensaje enviado. Los mensajes solo funcionan de forma unilateral lo cual imposibilita al candidato responder por medio de la aplicación móvil.', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/blockchain/blockchain.component.ts